import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'GenericCard',
  props: {
    color: {
        type: String,
        default: 'white',
    },
},
  setup(__props) {



return { __sfc: true, }
}

})